import { useState, useEffect, useCallback } from 'react';
import request from '../utils/request';

let cached = null;
let pending = null;

const listeners = new Set();

const notifyChange = () => {
  listeners.forEach(fn => fn());
};

export function invalidateSiteSettings() {
  cached = null;
  pending = null;
  notifyChange();
}

export default function useSiteSettings() {
  const [, force] = useState(0);
  const [settings, setSettings] = useState(cached);

  const load = useCallback(async () => {
    if (cached) {
      setSettings(cached);
      return;
    }
    if (pending) {
      const data = await pending;
      setSettings(data);
      return;
    }
    pending = request.get('/site-settings').then(res => {
      if (res.code === 200) {
        cached = res.data;
        return res.data;
      }
      return null;
    });
    const data = await pending;
    pending = null;
    setSettings(data);
  }, []);

  useEffect(() => {
    load();
    const listener = () => {
      // 缓存被清空后重新加载
      force(x => x + 1);
      setSettings(cached);
    };
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  }, [load]);

  return settings;
}
